import React from 'react';
import { motion } from 'framer-motion';
import '../styles/AuthorBlock.css';

const AuthorBlock = () => {
  return (
    <motion.div
      className="author-container"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6 }}
    >
      <div className="author-content">
        <div className="author-image-section">
          <div className="author-image-placeholder">
            <img
              src="/marin.jpg"
              alt="Alfonso Marín"
              className="author-image"
            />
          </div>
        </div>

        <motion.div
          className="author-text-section"
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h3 className="author-name">Alfonso Marín</h3>
          <p className="author-intro">
            Llevo <span className="highlight">14 años operando</span> y gestionando capital real.
            No vivo de vender cursos ni de promesas.
            Todo lo que enseño está respaldado con cuentas auditadas.
          </p>

          <div className="author-credentials">
            <div className="credential-item">
              <span className="credential-icon">💼</span>
              <p>
                <strong>No vivo de vender cursos.</strong> No tengo vida de lujos falsa
                "financiada" con trading.
              </p>
            </div>
            <div className="credential-item">
              <span className="credential-icon">📊</span>
              <p>
                <strong>Mi ingreso real proviene de operar.</strong> Gestiono un fondo público y
                uno privado retail de 6 cifras.
              </p>
            </div>
            <div className="credential-item">
              <span className="credential-icon">✅</span>
              <p>
                <strong>Todo con cuentas auditadas.</strong> Transparencia total en cada paso.
              </p>
            </div>
          </div>

          <p className="author-closing">
            Después de cientos de mensajes de mi comunidad… decidí abrir este entrenamiento.
            <br />
            <span className="emphasis">Y será solo una vez.</span>
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default AuthorBlock;
